import React from "react"
import PropTypes from "prop-types"

// components
import { Widget } from "quorumdesign"

// helpers
import { parseHtmlToReact } from "app/static/frontend/imports/desktopHelperFunctions"

const TextWidget = ({ description, editing, emptyPlaceholder, headerIcons, headerTitle, widgetKey }) => (
    <Widget
        description={description && parseHtmlToReact(description, widgetKey, false)}
        descriptionFull
        editing={editing}
        emptyPlaceholder={description ? null : emptyPlaceholder}
        headerIcons={headerIcons}
        headerTitle={headerTitle}
        id={widgetKey && `widget-${widgetKey}`}
        noHeader={!headerTitle}
        widgetKey={widgetKey}
    />
)

TextWidget.defaultProps = {}

TextWidget.propTypes = {
    editing: PropTypes.bool,
    emptyPlaceholder: PropTypes.string,
    description: PropTypes.string,
    headerIcons: PropTypes.array,
    headerTitle: PropTypes.string,
    widgetKey: PropTypes.string,
}

export default TextWidget
